<template>
  <v-form class="createCompanyForm" v-model="valid" ref="createCompanyForm">
    <v-container class="mb-10">
      <v-row>
        <v-col cols="12" md="3" sm="6" xs="12">
          <v-text-field
            v-model="company.name"
            :error-messages="error.name"
            label="Name"
            placeholder="Company Name"
            ref="firstInput"
            autofocus
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="3" sm="6" xs="12">
          <v-text-field
            v-model="company.unique_code"
            :error-messages="error.unique_code"
            label="Unique Code"
            placeholder="Company Unique Code"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="3" sm="6" xs="12">
          <v-text-field
            v-model="company.gst"
            :error-messages="error.gst"
            label="GST"
            placeholder="Company GST"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="3" sm="6" xs="12">
          <v-text-field
            v-model="company.sub_start_date"
            :error-messages="error.sub_start_date"
            type="date"
            label="Subscription Start Date"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="3" sm="6" xs="12">
          <v-text-field
            v-model="company.sub_end_date"
            :error-messages="error.sub_end_date"
            type="date"
            label="Subscription End Date"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="3" sm="6" xs="12">
          <v-textarea
            v-model="company.address"
            label="Address"
            placeholder="Company Address"
            rows="2"
          ></v-textarea>
        </v-col>

        <v-col cols="12" md="3" sm="6" xs="12" class="radio-with-lable">
          <label class="c-radio-label">Status</label>
          <v-radio-group v-model="company.status" row>
            <v-radio label="Active" :value="0" class="mt-0"></v-radio>
            <v-radio label="Inactive" :value="1" class="mt-0"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
    </v-container>
    <v-footer fixed>
      <v-col class="text-right">
        <v-btn color="primary" class="mr-2" @click="submit" small>{{ edit_id ? 'Update' : 'Add' }}</v-btn>
        <v-btn color="default" @click="reset" small>Reset</v-btn>
      </v-col>
    </v-footer>
  </v-form>
</template>

<script>
export default {
  watch: {
    $route: function () {
      this.edit_id = this.$route.params.id
      this.reset()
    }
  },
  mounted () {
    const id = this.$route.params.id
    if (id) {
      this.edit_id = id
      this.$axios.post('getCompanyById/' + id).then((res) => {
        this.company = res.data.data
      }).catch(() => {
        this.loading = false
        console.log('some error occurred')
      })
    } else {
      this.edit_id = undefined
    }
  },
  data () {
    return {
      valid: false,
      edit_id: undefined,
      company: { status: 0 },
      error: {},
    }
  },
  methods: {
    submit () {
      if (Object.keys(this.error).length > 0) {
        this.error = {}
        this.valid = true
      }
      if (this.valid) {
        const route = this.edit_id ? 'saveCompany/' + this.edit_id : 'saveCompany'
        this.$axios.post(route, this.company).then((res) => {
          this.$eventBus.$emit('$globalSnackbar', 'success', res.data.success_description)
          if (this.edit_id) {
            this.$router.push('/company')
          } else {
            this.reset()
          }
        }).catch((err) => {
          if (err.response.status === 422) {
            this.error = err.response.data.error_data
          } else {
            this.$eventBus.$emit('$globalSnackbar', 'red', err.response.data.error_description)
          }
        })
      } else {
        this.$refs.createCompanyForm.validate()
      }
    },
    reset () {
      this.$refs.createCompanyForm.reset()
      setTimeout(() => {
        this.company = { status: 0 }
        this.error = {}
        this.$refs.firstInput.focus()
      }, 300)
    },
  },
}
</script>
<style>
.createCompanyForm .radio-with-lable .v-input--selection-controls {
  margin-top: 0px;
}
.createCompanyForm .c-radio-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
</style>
